import React, { useMemo, useState } from 'react';
import {
  useModal,
  Flex,
  Text,
  RectangularButton as Button,
} from '@resideo/blueprint-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalHeader from '../ModalHeader';

interface ILeftNavContext {
  leftNavOpen: boolean;
  setLeftNavOpen: (isOpen: boolean) => void;
  openLogoutModal: () => void;
}

const GlobalVisualContext = React.createContext<ILeftNavContext>({
  leftNavOpen: false,
  setLeftNavOpen: () => ({}),
  openLogoutModal: () => ({}),
});

const GlobalVisualProvider = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [leftNavOpen, setLeftNavOpen] = useState(false);
  const {
    openModal: openLogoutModal,
    closeModal,
    Modal,
  } = useModal({ newDesign: true });

  const handleLogout = () => {
    navigate('/sign-out');
  };

  const value = useMemo(
    () => ({ leftNavOpen, setLeftNavOpen, openLogoutModal }),
    [leftNavOpen, setLeftNavOpen, openLogoutModal]
  );

  return (
    <GlobalVisualContext.Provider value={value}>
      {children}
      {/* Logout Modal */}
      <Modal>
        <ModalHeader
          title={t('header.signout')}
          closeModal={closeModal}
          textAlign='center'
        />
        <Text marginBottom='large' textAlign='center'>
          {t('header.signoutModalContent')}
        </Text>
        <Flex>
          <Button
            data-test-sign-out-modal-button
            variant='secondary'
            onClick={handleLogout}>
            {t('header.signout').toUpperCase()}
          </Button>
        </Flex>
      </Modal>
    </GlobalVisualContext.Provider>
  );
};

export const useGlobalProvider = () => React.useContext(GlobalVisualContext);

export default GlobalVisualProvider;
